Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPreviewQueryString = exports.getPreviewPageStore = void 0;

exports.getPreviewPageStore = function (adminCoreState) {
  if (!adminCoreState || !('pagePreview' in adminCoreState.modules)) {
    return;
  }

  var pagePreview = adminCoreState.modules.pagePreview;

  if (!pagePreview.store) {
    return;
  }

  return pagePreview.store;
};

exports.getPreviewQueryString = function (adminCoreState) {
  var store = exports.getPreviewPageStore(adminCoreState);

  if (store && store.state.inPreviewMode) {
    return '?preview';
  } else {
    return '';
  }
};